module.exports = __webpack_public_path__ + "static/media/0328_IMG_LE_SOL_MEGALITH_MEGABLACK.a39f0d65.png";